import React from 'react';
import FileUpload from 'b2b-ui-components-lib/lib/components/fileUpload';
import './uploadExcel.scss';

const uploadExcel = ({ title, body, fileUploadProps }) => {
  return (
    <div className="config_content">
      <h5>{title}</h5>
      <p> {body}</p>
      <div className="upload_document_area">
        <div className="upload_container">
          <FileUpload optionalProps={fileUploadProps?.accept} {...fileUploadProps} required />
          <div class="uploadedFiles">{fileUploadProps?.renderUploadedFiles}</div>
        </div>
      </div>
    </div>
  );
};

export default uploadExcel;
